<div class="gisApp">
    <section class="singleMap">
        <iframe *ngIf="mapURL" [src]="mapURL" allowfullscreen></iframe>
    </section>
    <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
</div>
